module.exports = __webpack_public_path__ + "static/media/meritmedical.f022bef3.jpeg";